import React, { useEffect } from 'react';
import { t } from '../../../i18n';
import SwiftXException from '../../../graphql/types/SwiftXException';


export interface SortingScanResponse {
    success: boolean;
    exception: SwiftXException;
    carrier: string;
    sortingCode: string;
    trackingNumber: string;
    dspName: string;
}

interface SortingScanOverlayProps {
    visible: boolean;
    data: SortingScanResponse;
    onClose: () => void;
}

const getSortingScanConfig = (data: SortingScanResponse) => {
    const baseConfigs = {
        SWIFTX: {
            color: 'text-purple-700',
            backgroundColor: 'bg-purple-200 bg-opacity-100',
        },
        USPS: {
            color: 'text-white',
            backgroundColor: 'bg-violet-950 bg-opacity-100',
        },
        ONTRAC: {
            color: 'text-red-700',
            backgroundColor: 'bg-red-200 bg-opacity-100',
        },
        UNIUNI: {
            color: 'text-orange-700',
            backgroundColor: 'bg-orange-200 bg-opacity-100',
        },
        FEDEX: {
            color: 'text-white',
            backgroundColor: 'bg-purple-900 bg-opacity-100',
        },
        CAINIAO: {
            color: 'text-white',
            backgroundColor: 'bg-blue-600 bg-opacity-100',
        },
        GOFO: {
            color: 'text-white',
            backgroundColor: 'bg-orange-600 bg-opacity-100',
        },
     };
    
    const baseConfig = baseConfigs[data.carrier as keyof typeof baseConfigs];
    if (baseConfig) return baseConfig;
    
    return  {
        color: 'text-black',
        backgroundColor: 'bg-white bg-opacity-100',
    };
};

export const SortingScanOverlay: React.FC<SortingScanOverlayProps> = ({
        visible,
        data,
        onClose,
    }) => {
    const config = getSortingScanConfig(data);
    
    useEffect(() => {
        if (visible) {
            const timer = setTimeout(onClose, 5000);
            return () => clearTimeout(timer);
        }
    }, [visible, onClose]);

    if (!config) {
        return null;
    }

    if (!visible) return null;

    const sortingCode = data.sortingCode?.split('-');


    return (
        <div 
            className={`fixed inset-0 screen h-screen z-50 flex flex-col items-center gap-3 justify-center ${config.backgroundColor}`}
        >
            <div
                className={`text-2xl mb-8 ${config.color}`}
            >
                {data.carrier}
            </div>
            <div 
                className={`text-5xl font-bold mb-4 ${config.color} text-center`}
            >
                {sortingCode?.[0]}-{sortingCode?.[1]}
            </div>
            <div 
                className={`text-5xl font-bold mb-4 ${config.color} text-center`}
            >
                {sortingCode?.[2]}
            </div>
            {data.dspName && (
                <div 
                    className={`text-4xl font-semibold ${config.color} text-center px-4`}
                >
                    {data.dspName}
                </div>
            )}
            <div 
                className={`text-2xl mt-8 ${config.color} break-all text-center px-1`}
            >
                {data.trackingNumber}
            </div>
        </div>
    );
};